import { CheckIcon } from 'lucide-react';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/shared/components';
import { useMediaQuery } from '@/shared/lib';
import type { Language } from '@/shared/types';
import { SUPPORTED_LANGUAGES } from '../config';

type Props = {
  language: Language;
  changeLanguage: (lng: Language) => void;
  onOpenChange?: (open: boolean) => void;
};

const LanguageSelect = ({ language, changeLanguage, onOpenChange }: Props) => {
  const isMobile = useMediaQuery('(max-width: 40rem)');
  return isMobile ? (
    <Select
      onValueChange={changeLanguage}
      onOpenChange={onOpenChange}
      defaultValue={language}>
      <SelectTrigger
        className="headline4 bg-white p-0 max-w-[2.5rem]"
        withChevron={false}>
        <SelectValue>{language.toUpperCase()}</SelectValue>
      </SelectTrigger>
      <SelectContent classNameViewport="min-w-full">
        {SUPPORTED_LANGUAGES.map(lng => (
          <SelectItem key={lng} value={lng} className="headline4">
            {lng.toUpperCase()}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  ) : (
    <HoverCard onOpenChange={onOpenChange}>
      <HoverCardTrigger className="headline4 cursor-pointer border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-md bg-transparent px-3 py-2 text-sm whitespace-nowrap transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8">
        {language.toUpperCase()}
      </HoverCardTrigger>
      <HoverCardContent className="p-1 w-fit">
        {SUPPORTED_LANGUAGES.map(lng => (
          <div
            key={lng}
            className="headline4 cursor-pointer focus:bg-accent focus:text-accent-foreground relative flex w-full  items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 hover:bg-accent hover:text-accent-foreground"
            onClick={() => {
              changeLanguage(lng);
            }}>
            {lng.toUpperCase()}
            {lng === language && (
              <CheckIcon className="absolute right-0 size-7 text-primary" />
            )}
          </div>
        ))}
      </HoverCardContent>
    </HoverCard>
  );
};

export { LanguageSelect };
